
import $ from 'jquery';

/**
 * Custom Scripts
 */
import Form from './custom/forms';
// import SocialMedia from './custom/bjzm-social-feeds';
import BjzmScripts from './custom/bjzm-scripts';
import Slider from './custom/bjzm-slideshow.js';

import BjzmLoadMorePosts from './custom/bjzm-load-more-posts';
import HeaderScroll from './custom/header-scroll';
import SinglePageUpdown from './custom/single-page-updown';
import BjzmFormScripts from './custom/bjzm-form-scripts';
import AppWebApiUtilities from './custom/app-web-api-utilities';

import Maps from './custom/bjzm-maps';
import Timeline from './custom/bjzm-timeline';
import Animations from './custom/animations';

/**
 * Vendors
 */
import matchHeight from './vendors/jquery.matchHeight';
import magnificPopup from 'magnific-popup';
import SingleMap from './custom/bjzm-single-map';

jQuery(window).on('load',function(){
	new Timeline();
	new Animations();    
})

jQuery(document).ready(function($) {

 	var ThemeScripts = new BjzmScripts();
 	var RegisterFormScripts = new BjzmFormScripts();
 	new SingleMap();
 	// var WebApiUtilities = AppWebApiUtilities();
 	
	/* Load More Posts */
	var LoadMorePosts = new BjzmLoadMorePosts({
		query_vars: BJZM_DATA.query_vars,
		ajax_url: BJZM_DATA.ajaxurl,
		max_num_pages: BJZM_DATA.max_num_pages,
		post_loop: $(".bjzm-wrapper__row--blog-posts"),
		template_partial: 'content-full-width-article'
	});

	// new Maps();

	var subMenuScroll = new SinglePageUpdown({
		container: $(".submenu"),
		offset: 130,
		callBack: function() {
			 ThemeScripts.closeMobileMenu()
		}
	});

	/* Homepage Slideshow*/
	var HomeSlider = new Slider("home_slider", {
		dots: true,
		customPaging : function(slider, i) {
 			return '<a href="#" class="slider__dots"></a>';
 		}
 	});


	/* Header Scroll */
	var MainHeaderScroll = new HeaderScroll({
		header: $(".header__inner--mobile"),
		threshold: 300,
		class: 'header--collapsed'
	});
	

	/*privacy policy*/
	$('.lightbox').magnificPopup({
 		type: 'inline',
		midClick: true,
		removalDelay: 300,
		mainClass: 'mfp-fade mfp-wrap--privacy-policy'
	});


	$(".show-hero").change(function(){
		$(".home-wrapper").toggleClass('hero-map');
	});	

	/* ACCORDION */

	let accRow = $('.accordion__row');

	$('.accordion__row').on('click', function(){
		let curRow = $(this);
		if(curRow.hasClass('accordion__row--inactive')){

			if(accRow.hasClass('accordion__row--active')){
				accRow.removeClass('accordion__row--active');
				accRow.addClass('accordion__row--inactive');
			}
			
			curRow.removeClass('accordion__row--inactive');
			curRow.addClass('accordion__row--active');

		}else{

			accRow.removeClass('accordion__row--active');

			if(accRow.hasClass('accordion__row--inactive')){
				accRow.addClass('accordion__row--inactive');
			}
		}
	});
});








